<template>
  <md-card>
    <md-card-header class="md-card-header-text md-card-header-primary">
      <div class="card-text" style="display: block;background: grey;">
        <!--<md-icon>list_alt</md-icon>-->
        <h4 class="title" style="color: white;">{{ $t("Credit Card") }}</h4>
      </div>
    </md-card-header>
    <md-card-content>
      <div class="md-layout" v-if="card_last4 !== undefined">
        <div class="md-layout-item md-size-100 alert alert-warning">
          <label>
            <b>{{ $t("Saved Card") }}</b>
            &nbsp;&nbsp;&nbsp;&nbsp;{{ card_brand }}&nbsp;&nbsp;&nbsp;&nbsp; • •
            • • {{ card_last4 }}&nbsp;&nbsp;&nbsp;&nbsp;{{
              card_expire_month
            }}
            / {{ card_expire_year }}
          </label>
        </div>
      </div>
      <div class="md-layout">
        <div class="md-layout-item md-size-100" ref="card"></div>
        <div
          class="md-layout-item md-size-100 text-right"
          style="margin-top:10px"
        >
          <md-button
            v-if="card_last4 !== undefined"
            style="margin-right:20px"
            @click="deleteCard"
            class="md-raised md-primary mt-4"
            >{{ $t("Delete Card") }}</md-button
          >
          <md-button @click="createCard" class="md-raised md-primary mt-4">{{
            $t("Update Card")
          }}</md-button>
        </div>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
import swal from "sweetalert2";
import { mapFields } from "vuex-map-fields";
import { STRIPE_KEY } from "@/helpers";
import { loadStripe } from "@stripe/stripe-js";

export default {
  data() {
    return {
      card: null,
      stripe: null,
      responsive: false
    };
  },
  props: {
    headerColor: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapFields("auth", [
      "card_brand",
      "card_expire_month",
      "card_expire_year",
      "card_last4",
      "plan_type"
    ])
  },
  methods: {
    onResponsiveInverted() {
      if (window.innerWidth < 768) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    createCard() {
      if (
        this.$store.state.auth.firstname === undefined ||
        this.$store.state.auth.lastname === undefined ||
        this.$store.state.auth.phone === undefined ||
        this.$store.state.auth.street === undefined ||
        this.$store.state.auth.city === undefined ||
        this.$store.state.auth.province === undefined ||
        this.$store.state.auth.postalcode === undefined ||
        this.$store.state.auth.firstname === "" ||
        this.$store.state.auth.lastname === "" ||
        this.$store.state.auth.phone === "" ||
        this.$store.state.auth.street === "" ||
        this.$store.state.auth.city === "" ||
        this.$store.state.auth.province === "" ||
        this.$store.state.auth.postalcode === ""
      ) {
        swal.fire({
          title: this.$t("Please update profile first"),
          text: this.$t(
            "Profile must be filled in completely to add credit card information."
          ),
          type: "warning",
          confirmButtonClass: "md-button md-warning",
          buttonsStyling: false
        });
      } else {
        // createToken returns a Promise which resolves in a result object with
        // either a token or an error key.
        // See https://stripe.com/docs/api#tokens for the token object.
        // See https://stripe.com/docs/api#errors for the error object.
        // More general https://stripe.com/docs/stripe.js#stripe-create-token.
        this.stripe.createToken(this.card).then(result => {
          if (!result.error) {
            this.$store.dispatch("subscription/createCard", {
              token_id: result.token.id
            });

            swal.fire({
              title: this.$t("You successfully updated card!"),
              type: "success",
              confirmButtonClass: "md-button md-success",
              buttonsStyling: false
            });
          } else {
            swal.fire({
              title: this.$t("Failed to update card!"),
              type: "error",
              confirmButtonClass: "md-button md-danger",
              buttonsStyling: false
            });
          }
        });
      }
    },
    deleteCard() {
      if (this.plan_type !== undefined) {
        swal.fire({
          title: this.$t(
            "You need to cancel subscription first before you can delete your card!"
          ),
          type: "warning",
          confirmButtonClass: "md-button md-warning",
          buttonsStyling: false
        });
        return;
      }
      swal
        .fire({
          title: this.$t("Are you sure you want to do this?"),
          text: this.$t(
            "Your service will be interrupted if we failed to process your recurring payment!"
          ),
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          onfirmButtonText: this.$t("Yes"),
          cancelButtonText: this.$t("Cancel"),
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.$store.dispatch("subscription/deleteCard");
            swal.fire({
              title: this.$t("You successfully deleted card!"),
              type: "success",
              confirmButtonClass: "md-button md-success",
              buttonsStyling: false
            });
          }
        });
    }
  },
  async mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);

    let style = {
      base: {
        color: "#32325d",
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "#aab7c4"
        }
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a"
      }
    };

    console.log(STRIPE_KEY);
    var locale = window.localStorage.getItem("locale");
    locale = locale ? locale : "en";
    this.stripe = await loadStripe(STRIPE_KEY, {
      locale: locale
    });
    var elements = this.stripe.elements();
    this.card = elements.create("card", { hidePostalCode: true, style: style });
    this.card.mount(this.$refs.card);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);

    this.card.destroy(this.$refs.card);
  }
};
</script>
<style lang="css">
.StripeElement {
  box-sizing: border-box;
  height: 40px;

  padding: 50px 12px 54px 12px;

  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>
